import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { PageData } from '../../../content/models';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IconComponent } from '@teamfoster/sdk/icon';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, IconComponent, RouterLinkActive],
})
export class PaginationComponent {
  readonly pages = input.required<number[]>();
  readonly page = input.required<PageData>();
  readonly pageSize = input(5);
}
